import { client } from "./client";

const ROUTES = {
    getUsersPermissionsExtraTableData: () => `/get_users_permissions_table/extra/`,
};

export const UsersPermissions = {
    getUsersPermissionsExtraTableData: () => {
        return client.get(ROUTES.getUsersPermissionsExtraTableData());
  }
};